import React from "react";
import { Outlet } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { AppHeader } from "./AppHeader";
import { useAuth } from "../../contexts/AuthContext";
import { useAnswerSync } from "../../offline/useAnswerSync";
import { OfflineBanner } from "../features/Offline/OfflineBanner";

/**
 * AppShell: Header + Outlet + BottomNav のメインレイアウト
 * MASTER.md の App Shell Structure に準拠
 */
export const AppShell: React.FC = () => {
  const { user } = useAuth();
  useAnswerSync(user?.idToken);

  return (
    <div className="min-h-[100dvh] bg-slate-50 dark:bg-slate-900">
      <AppHeader />
      <OfflineBanner />
      {/* BottomNav は全画面幅で固定表示のため、下余白も全幅で確保する（lg:pb-0 だと最下部コンテンツがナビに隠れる） */}
      <main className="min-h-[calc(100dvh-128px)] pb-28">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  );
};
